import MyAccountLoginTrigger from "@pages/MyAccount/components/MyAccountLoginTrigger";
import { MyAccountEmptyStateMyBTConstants } from "@pages/MyAccount/utils/constants";

/**
 * MyAccountPopoverLoginMyBTLoginState is a component displayed in my account myBT popover when the user is not logged in.
 * Figma: https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3623-20677&t=XsTPoO6b0V5zVeJ1-4
 */
const MyAccountPopoverLoginMyBTLoginState = (): React.ReactElement => {
  return (
    <div
      data-testid="my-account-my-bt-login-state-component"
      className="w-[360px] p-6 text-center"
    >
      <img
        src={MyAccountEmptyStateMyBTConstants.src}
        alt="my account myBT"
        width={180}
        height={170}
        className="mx-auto mb-8 mt-10"
      />

      <div className="mb-4">
        <p className="mb-0 font-poppins font-bold text-gray-850">
          {MyAccountEmptyStateMyBTConstants.title}
        </p>
        <p className="font-xs mb-0 font-poppins text-gray-850">
          {MyAccountEmptyStateMyBTConstants.description}
        </p>
      </div>

      <MyAccountLoginTrigger className="mx-auto rounded-[50px] border border-gray-175 bg-none px-10 py-4 lg:hover:bg-transparent" />
    </div>
  );
};

export default MyAccountPopoverLoginMyBTLoginState;
